const Joi = require("joi");

const noticeListSchema = (data) => {
  const schema = Joi.object({
    FacilityCode: Joi.array().min(1).required().messages({
      "array.min": "Please select Facility.",
      "any.required": "Please select Facility.",
    }),

    replicateStartDate: Joi.string()
      .trim()
      .required()
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/)
      .messages({
        "string.empty": "Please enter Start Date.",
        "any.required": "Please enter Start Date.",
        "string.pattern.base":
          " Please enter Start Date must be in MM/DD/YYYY format.",
      }),

    replicateEndDate: Joi.string()
      .trim()
      .required()
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/)
      .custom((value, helpers) => {
        const { replicateStartDate } = helpers.state.ancestors[0];
        const start = new Date(replicateStartDate);
        const end = new Date(value);
        if (end < start) {
          return helpers.message(
            "End Date must be greater than or equal to Start Date."
          );
        }
        return value;
      })
      .messages({
        "string.pattern.base": "End Date must be in MM/DD/YYYY format.",
        "string.empty": "Please enter End Date.",
        "any.required": "Please enter End Date.",
      }),
  }).unknown(true);
  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = noticeListSchema;
